import i18n from '@/utils/i18n';

const fields =
  {
    user: [
      {
        name: "first_name",
        type: "text",
        columns: 6,
        required: true,
        placeholder: i18n.t('users.first_name')
      },
      {
        name: "last_name",
        type: "text",
        columns: 6,
        required: true,
        placeholder: i18n.t('users.last_name')
      },
      {
        name: "company",
        type: "text",
        columns: 6,
        required: true,
        placeholder: i18n.t('users.company')
      },
      {
        name: "job",
        type: "text",
        columns: 6,
        required: true,
        placeholder: i18n.t('users.job')
      },
      {
        name: "email",
        type: "email",
        required: true,
        columns: 12,
        placeholder: i18n.t('users.email')
      }
    ],
    resource: [
      {
        name: "host",
        type: "url",
        required: true,
        columns: 12,
        value: 'https://',
        placeholder: i18n.t('form.website_url')
      },
      {
        name: "title",
        type: "text",
        required: true,
        columns: 12,
        placeholder: i18n.t('form.website_name')
      }
    ],
    extra: [
      {
        title: i18n.t('onboarding.questions.sales_software'),
        name: "sales_software",
        options: [
          {
            title: "Hubspot",
            type: "checkbox"
          },
          {
            title: "Streak",
            type: "checkbox"
          },
          {
            title: "Salesforce",
            type: "checkbox"
          },
          {
            title: i18n.t('global.other'),
            name: "other",
            type: "checkbox"
          }
        ]
      },
      {
        title: i18n.t('onboarding.questions.mailing_software'),
        name: "mailing_software",
        options: [
          {
            title: "Mailchimp",
            type: "checkbox"
          },
          {
            title: "Campaign Monitor",
            type: "checkbox"
          },
          {
            title: "Constant Contact",
            type: "checkbox"
          },
          {
            title: "Sailthru",
            type: "checkbox"
          },
          {
            title: i18n.t('global.other'),
            name: "other",
            type: "checkbox"
          }
        ]
      },
      {
        title: i18n.t('onboarding.questions.chat_software'),
        name: "chat_software",
        options: [
          {
            title: "Slack",
            type: "checkbox"
          },
          {
            title: "Chatlio",
            type: "checkbox"
          },
          {
            title: i18n.t('global.other'),
            name: "other",
            type: "checkbox"
          }
        ]
      },
      {
        title: i18n.t('onboarding.questions.payment_system'),
        name: "payment_system",
        options: [
          {
            title: "Stripe",
            type: "checkbox"
          },
          {
            title: "Chase",
            type: "checkbox"
          },
          {
            title: i18n.t('onboarding.questions.wallkits_payment_method'),
            value: 'custom',
            type: "checkbox"
          },
          {
            title: i18n.t('global.other'),
            name: "other",
            type: "checkbox"
          }
        ]
      },
      {
        title: i18n.t('onboarding.questions.other_services'),
        name: "other_services",
        options: [
          {
            type: "textarea"
          }
        ]
      }
    ]
  };


export default fields
